<div class="title">{{ data[purpose].type | translate }}</div>
<ul class="list">
	@for (option of data[purpose].options; track $index) {
		<li>{{ option | translate }}</li>
	}
</ul>
